import type { NodeProps } from '../types';
import { BaseEmbed } from './lib/base-embed';

export function Infogram({ props }: NodeProps<{ id: string }>) {
  return (
    <BaseEmbed src={`https://e.infogr.am/${props.id}?src=embed#async_embed`} title="Infogram" />
  );
}
